export default __webpack_public_path__ + "static/media/logo-sanjivani.e002693b.jpg";